<template>
    <div class="inventoryVerification">
        <HeaderNav header-title="库存盘点列表" left-icon-name="2" right-icon-name="3" :extr="{ leftCallBack: swiperright }"></HeaderNav>
        <div class="content">
            <div class="search">
                <div class="search_top">
                    <div class="time" @click="handleShowCalendar">
                        <div class="start">
                            <van-icon class="time_icon" name="calendar-o"></van-icon>
                            <span>{{ search.startTime }}</span>
                        </div>
                        <div class="line">
                            —
                        </div>
                        <div class="end">
                            <van-icon class="time_icon" name="calendar-o"></van-icon>
                            <span>{{ search.endTime }}</span>
                        </div>
                    </div>
                    <div class="select" @click="openSelectPopuo('Status')">
                        <span>{{ search.Status }}</span>
                        <van-icon class="sel_icon" name="arrow-down"></van-icon>
                    </div>
                </div>
                <div class="search_center">
                    盘点差异：
                    <van-radio-group v-model="search.IsDiffer" @change="changeFn" direction="horizontal">
                        <van-radio @click="clickFn(true)" :name="true">
                            是
                        </van-radio>
                        <van-radio @click="clickFn(false)" :name="false">
                            否
                        </van-radio>
                    </van-radio-group>
                </div>
                <div class="search_bottom">
                    <van-search v-model="search.keyword" placeholder="请输入搜索内容···"></van-search>
                    <div class="btn" @click="searchFun">
                        查询
                    </div>
                </div>
            </div>
            <div class="list_box">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                    <div class="list_item" v-for="(item, index) in list" :key="index">
                        <p class="title">
                            <span>盘点单编号：</span>{{ item.CheckNo }}
                            <span class="btn" v-if="item.status === 0">
                                {{ item.state_name }}
                            </span>
                            <span class="btn btn_no" v-if="item.status === 1 || item.status === 2">
                                {{ item.state_name }}
                            </span>
                            <span class="btn btn_ok" v-if="item.status === 3 || item.status === 4">
                                {{ item.state_name }}
                            </span>
                        </p>
                        <div class="ps_box">
                            <p><img src="@/assets/images/icons/icon_4@2x.png"><span>库位编号：</span>{{ item.GridCode }}</p>
                            <p><img src="@/assets/images/icons/icon_7@2x.png"><span>库位名称：</span>{{ item.GridName }}</p>
                            <p><img src="@/assets/images/icons/icon_5@2x.png"><span>仓库名称：</span>{{ item.StockName }}</p>
                            <p><img src="@/assets/images/icons/icon_13@2x.png"><span>物料代码：</span>{{ item.MaterialCodes }}</p>
                            <p><img src="@/assets/images/icons/icon_29@2x.png"><span>短描述：</span>{{ item.MaterialShortNames }}</p>
                            <p><img src="@/assets/images/icons/icon_2@2x.png"><span>单位：</span>{{ item.Unit }}</p>
                            <p><img src="@/assets/images/icons/icon_6@2x.png"><span>盘点前库存：</span>{{ item.VolumeCurrent }}</p>
                            <p><img src="@/assets/images/icons/icon_6@2x.png"><span>盘点后库存：</span>{{ item.VolumeCheck }}</p>
                            <!-- <p><img src="@/assets/images/icons/icon_6@2x.png"><span>最大库存：</span>{{ item.VolumeMax }}</p> -->
                            <p><img src="@/assets/images/icons/icon_6@2x.png"><span>期间入库：</span>{{ item.DuringInStockVolume }}</p>
                            <p><img src="@/assets/images/icons/icon_6@2x.png"><span>期间出库：</span>{{ item.DuringOutStockVolume }}</p>
                            <p><img src="@/assets/images/icons/icon_38@2x.png"><span>盘点差异：</span>{{ item.VolumeDiffer }}</p>
                            <p><img src="@/assets/images/icons/icon_8@2x.png"><span>盘点人：</span>{{ item.CheckUserName }}</p>
                            <p><img src="@/assets/images/icons/icon_7@2x.png"><span>盘点时间：</span>{{ item.CheckTime }}</p>
                            <template v-if="item.Status == 0">
                                <van-button class="opt_btn" plain type="danger" @click="toDetail(item)">
                                    编辑
                                </van-button>
                            </template>
                            <template v-else>
                                <van-button class="opt_btn" plain type="danger" @click="toDetail(item)">
                                    查看
                                </van-button>
                            </template>
                        </div>
                    </div>
                </van-list>
            </div>
            <div class="btn-con">
                <van-button class="btn save-btn" @click="addFun">
                    盘点
                </van-button>
            </div>
        </div>
        <van-calendar
            type="range"
            v-model="showCalendar"
            :min-date="minDate"
            :default-date="defaultDate"
            @confirm="confirmMonth"
        ></van-calendar>
        <van-popup v-model="showSelectPopuo" position="bottom" :style="{ height: '40%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="selectList"
                :value-key="valueKey"
                @confirm="confirmSelect"
                @cancel="showSelectPopuo = false"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import currencyFun from '@/assets/js/currencyFun/index.js';
import { Toast } from 'vant';
export default {
    name: 'inventory-verification',
    components: {
        HeaderNav,
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'inventory-verification');
        }
        next();
    },
    data() {
        return {
            page: {
                pageindex: 1,
                pagesize: 3,
            },
            search: {
                keyword: '',
                startTime: '',
                endTime: '',
                IsDiffer: null,
                Status: '全部',
            },
            loading: false,
            finished: false,
            list: [],
            // 日历
            showCalendar: false,
            minDate: new Date(2000, 0, 1),
            defaultDate: [],

            StatusDatas: [
                {
                    name: '全部',
                    value: '',
                },
                {
                    name: '盘点中',
                    value: 0,
                },
                {
                    name: '已提交',
                    value: 1,
                },
                {
                    name: '已退回',
                    value: 2,
                },
                {
                    name: '已确认',
                    value: 3,
                },
            ],
            selectList: [],
            valueKey: '',
            popuoType: '',
            showSelectPopuo: false,
            checkRadioFlag: false,
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.searchFun();
        }
    },
    created() {
        window.jyCallback_DriveScanFinished = this.jyCallback_DriveScanFinished_kcpd;
        const dates = currencyFun.getMonthData();
        this.search.startTime = dates.startDate;
        this.search.endTime = dates.endDate;
    },
    mounted() {},
    computed: {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        async openSelectPopuo(type) {
            this.popuoType = type;
            this.showSelectPopuo = true;
            if (type === 'Status') {
                this.selectList = ['全部', '盘点中', '已提交', '已退回', '已确认'];
                this.valueKey = '';
            }
        },
        confirmSelect(val, index) {
            if (this.popuoType === 'Status') {
                this.search.Status = val;
            }
            this.showSelectPopuo = false;
        },
        // 查询
        searchFun() {
            this.page.pageindex = 1;
            this.list = [];
            this.loading = true;
            this.finished = false;
            this.onLoad();
        },
        clickFn() {
            // 单选取消
            if (this.checkRadioFlag) {
                this.search.IsDiffer = null;
            }
            this.checkRadioFlag = true;
        },
        changeFn() {
            this.checkRadioFlag = false;
        },
        // 展示日历
        handleShowCalendar() {
            this.defaultDate = [new Date(this.search.startTime), new Date(this.search.endTime)];
            this.showCalendar = true;
        },
        // 登记时间-确认选择
        confirmMonth(val) {
            this.search.startTime = currencyFun.timeFormat(new Date(val[0]), 'yyyy-MM-dd');
            this.search.endTime = currencyFun.timeFormat(new Date(val[1]), 'yyyy-MM-dd');
            this.showCalendar = false;
        },
        onLoad() {
            // 异步更新数据
            const par = {
                CheckTimeMin: this.search.startTime,
                CheckTimeMax: this.search.endTime,
                Status: this.search.Status ? this.StatusDatas.filter(item => { return item.name === this.search.Status; })[0].value : '',
                IsDiffer: this.search.IsDiffer,
                PageSize: this.page.pagesize,
                PageIndex: this.page.pageindex,
                SearchKey: this.search.keyword,
            };
            if (this.search.IsDiffer !== '') {
                par.IsDiffer = this.search.IsDiffer;
            }
            this.$axios.post('/interfaceApi/procurement/stock_grid_check/page_list', par).then(res => {
                // 加载状态结束
                this.loading = false;
                if (this.page.pageindex === 1) {
                    this.list = res.rows;
                } else {
                    this.list.push(...res.rows);
                }
                // 数据全部加载完成
                if (this.list.length >= res.total) {
                    this.finished = true;
                } else {
                    this.page.pageindex += 1;
                }
            }).catch(error => {
                Toast(error.ErrorCode.Message);
            });
        },
        toDetail(item) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/inventoryVerificationDetail',
                query: {
                    id: item.Id,
                } });
        },
        addFun() {
            this.$callMobile('JYExternalNative', 'jyDriveScanClick');
        },
        jyCallback_DriveScanFinished_kcpd(val) {
            const data = JSON.parse(`${val}`.slice(1, -1));
            this.$router.isBack = 2;
            this.$router.push({
                path: '/inventoryVerificationDetail',
                query: {
                    id: '',
                    pdId: data.grid_code, // 盘点id
                    isView: false,
                    openType: 'add',
                } });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.inventoryVerification
    background #F0F0F0
    display: flex
    flex-direction column
    .content
        flex 1
        height 0
        .search
            background #fff
            padding 12rpx 12rpx 5rpx 12rpx
            .search_top
                display flex
                height 50rpx
                .time
                    display flex
                    height 40rpx
                    width calc(76% - 10rpx)
                    background #F0F0F0
                    align-items: center
                    justify-content: space-around;
                    border-radius: 4px
                    margin-right: 10rpx
                    font-size: 14rpx
                    .start,.end
                        height 100%
                        display: flex;
                        align-items: center;
                        .time_icon
                            margin-right 5rpx
                            font-size 18rpx
                            line-height: 18rpx
                        span
                            font-size 14rpx
                            line-height: 18rpx
                    .line
                        width 16rpx
                        text-align: center
                .select
                    width 24%
                    height 40rpx
                    display flex
                    background #F0F0F0
                    align-items: center
                    justify-content: center
                    border-radius: 4px
                    .sel_icon
                        margin-left: 3rpx;
            .search_center
                height 40rpx
                // margin 10rpx 12rpx 0 12rpx
                background #F0F0F0
                border-radius: 4px
                padding-left 15rpx
                display: flex
                align-items: center
        .search_bottom
            display flex
            >>>.van-search
                background #fff !important
                height 45rpx !important
                width calc(76% - 10rpx)
                padding 0 !important
                margin-right: 10rpx
            >>>.van-search__content
                background #F0F0F0 !important
            .btn
                width 24%
                height 30rpx
                display flex
                background #F0F0F0
                align-items: center
                justify-content: center
                border-radius: 4px
                margin-top 8rpx
                color #E93743
                border 1px solid #f8c7c9
                background #fcebec
        .btn-con
            display flex
            position fixed
            width 100%
            height 59rpx
            bottom 0
            z-index 0
            background #fff
            padding 10rpx 14rpx
            .btn
                flex 1
                height 39rpx
                text-align center
                line-height 39rpx
                cursor pointer
            .submit-btn
                background #fcebec
                border 1px solid #f9cdcf
                color #ea4b49
                margin-right 18rpx
            .save-btn
                color #fff
                background: linear-gradient(to right, #EB6348, #e93543);
        .list_box
            width 100%
            height calc(100% - 213rpx)
            overflow-y scroll
            padding 15px
            .list_item
                background #fff
                margin-bottom 15rpx
                box-shadow: 0px 0px 3px 0px #b5b5b5;
                border-radius: 8rpx;
                position relative
                .title
                    width 100%
                    height 42rpx
                    background #F8F8F8
                    margin-bottom 0 !important
                    display flex
                    align-items center
                    padding-left 20rpx
                    box-shadow: 0px 2px 3px -2px #b5b5b5;
                    font-size 15rpx
                    position relative
                    border-radius: 8rpx 8rpx 0 0;
                    span
                        color: #000 !important
                    .btn
                        position absolute
                        top 0
                        right 0
                        color #fff !important
                        font-size 12rpx !important
                        background: #F85B5B;
                        padding 1.5rpx 5rpx
                        border-radius: 0 8rpx
                        font-weight: 500 !important;
                        &.btn_ok
                            background #979EA7 !important
                        &.btn_no
                            background #409CFF !important
                .ps_box
                    padding 15px
                    p
                        display: flex;
                        align-items: center;
                        font-size 14rpx
                        img
                            width 20rpx
                            height 20rpx
                            margin-right 5rpx
                p
                    margin-bottom 10px
                    color #626262
                    &:last-child
                        margin-bottom 0
                >>>.van-button--plain.van-button--danger
                    background: #fcebec;
                    height 25rpx
                    position absolute
                    bottom 25rpx
                    right 10rpx

</style>
